"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reifyProps = exports.flattenProps = void 0;
var lodash_1 = require("lodash");
var memoize_weak_1 = __importDefault(require("memoize-weak"));
// DO NOT USE only exported for testing purposes
exports.flattenProps = function (props) {
    return lodash_1.toPairs(props).reduce(function (flattened, pair) { return __spread(flattened, pair); }, []);
};
// DO NOT USE only exported for testing purposes
exports.reifyProps = function (propPairs) {
    return lodash_1.chunk(propPairs, 2).reduce(function (props, pair) {
        var _a;
        return (__assign(__assign({}, props), (_a = {}, _a[pair[0]] = pair[1], _a)));
    }, {});
};
// Create a cache which keys objects based on
// the shallow references of their key/value pairs
var objectCache = function (fn, options) {
    if (fn === void 0) { fn = lodash_1.identity; }
    if (options === void 0) { options = {
        debug: false,
    }; }
    var memoizedFn = memoize_weak_1.default(function () {
        var propPairs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            propPairs[_i] = arguments[_i];
        }
        return fn(exports.reifyProps(propPairs));
    });
    return function (props) {
        if (options.debug)
            console.info(props);
        var args = exports.flattenProps(props);
        return memoizedFn.apply(void 0, __spread(args));
    };
};
exports.default = objectCache;
